// Query keys centralizadas y jerárquicas del dominio vacancy.
export const vacancyKeys = {
  all: ["vacancy"],
  list: () => [...vacancyKeys.all, "list"],
  detail: (id: string | undefined) => [...vacancyKeys.all, "detail", id],
  applications: () => [...vacancyKeys.all, "applications"],
};
